// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1nn3t","icon":"SortAdornment_icon__1NF8G","up":"SortAdornment_up__2iSvI","down":"SortAdornment_down__11pb0","active":"SortAdornment_active__NypKx"};